module.exports = __webpack_public_path__ + "img/lg_ring_r_0_1_1.e52fe8f9.png";